module.exports = __webpack_public_path__ + "img/supervision_1920.32da34b7.png";